import * as React from "react";
import { OI } from "../onam/mark";
import { FEATURES } from "../onam/features";

type Props = React.SVGProps<SVGSVGElement> & { title?: string };

function BaseDownIcon({ title, ...props }: Props) {
  return (
    <svg
      width={20}
      height={10}
      viewBox="0 0 20 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role="img"
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <g clipPath="url(#clip0_1258_30228)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99954 7.21507L15.892 1.32257L17.0704 2.50091L10.5887 8.98257C10.4324 9.1388 10.2205 9.22656 9.99954 9.22656C9.77857 9.22656 9.56665 9.1388 9.41038 8.98257L2.92871 2.50091L4.10704 1.32258L9.99954 7.21507Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1258_30228">
          <rect
            width={10}
            height={20}
            fill="white"
            transform="translate(0 10) rotate(-90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

/* With the ONAM skin (FEATURES.curationSkin) this draws ONAM's "down" glyph instead (onam/mark.tsx). */
const DownIconSkin = (props: any) =>
  FEATURES.curationSkin ? (
    <OI n="down" size={props.size || 16} className={props.className} style={props.style} onClick={props.onClick} title={props.title} color={props.color}
      onMouseOver={props.onMouseOver} onMouseOut={props.onMouseOut} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave} />
  ) : (
    <BaseDownIcon {...props} />
  );
export default DownIconSkin;
